import React from 'react'
import { Redirect } from 'react-router-dom'
import { UNAUTHORIZED } from '../../constants/Paths'
import isAdminUser from '../../helpers/isAdminUser'
import { useAppSelector } from '../../hooks'
import CommonLoadingView from '../common/CommonLoadingView'

type Props = {
  children: JSX.Element
}

/**
 * チーム管理者以外を締め出すルートガード。
 * RequireAuthの内側で使い、認証済みかつadminのユーザーにのみchildrenを描画する。
 * サーバー側も403を返すため、ここでの判定はあくまでUIレベルの防御。
 */
const RequireAdmin = ({ children }: Props) => {
  const user = useAppSelector((state) => state.user.user)

  // RequireAuthのユーザー取得が完了するまでは判定できないため描画を保留する
  if (!user) return (<CommonLoadingView />)

  if (!isAdminUser(user)) return <Redirect to={UNAUTHORIZED} />

  return children
}

export default RequireAdmin
